import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import WorkQueues from 'enums/workQueue.enum';
import { listFailedAdjudicationsByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import ReviewAdjudicationFilterButton from './ReviewAdjudicationFilterButton';
import ReviewAdjudicationFilterStatusBar from './ReviewAdjudicationFilterStatusBar';
import ReviewAdjudicationTable from './ReviewAdjudicationTable';

const ReviewAdjudication = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(
    ({ workQueue }) => workQueue.reviewAdjudication,
    shallowEqual
  );
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.REVIEW_ADJUDICATION)) {
      dispatch(listFailedAdjudicationsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.REVIEW_ADJUDICATION) return null;

  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <ReviewAdjudicationFilterStatusBar />
      </Grid>
      <Grid item>
        <ReviewAdjudicationFilterButton />
      </Grid>
      <ReviewAdjudicationTable />
    </Grid>
  );
};

export default ReviewAdjudication;
